import Header from '../../components/Header';
import Footer from '../../components/Footer';

import ImageAboutBanner from '../../assets/about-banner.jpg';

import { AboutContainer, AboutBanner, Section } from './styles';

function About() {
  return (
    <AboutContainer>
      <Header page="about" />

      <AboutBanner>
        <img src={ImageAboutBanner} alt="About banner" />

        <div className="content">
          <div className="text">
            <h1>Sobre nós</h1>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus repellendus consectetur eaque, dignissimos harum </p>
          </div>
        </div>
      </AboutBanner>

      <Section id="about-content">
        <div className="content">
          <div className="circle-lines"></div>

          <div className="heading">
            <div className="text">
              <h1>
                Nosso compromisso é melhorar o delivery conectando restaurantes e consumidores.
              </h1>

              <p>
                Investimos em  deixar o delivery ainda melhor e mais barato para você, conectando clientes e empresas através da tecnologia.
              </p>
            </div>
          </div>

          <div className="video">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/M9tsD9XePbc?controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </div>
        </div>
      </Section>

      <Footer />
    </AboutContainer>
  );
};

export default About;
